<template>
<div class="header">
  <heading>{{ title }}</heading>
  <heading><a @click.prevent="addClicked" :class="{'is-stepped': stepped}">{{label}}</a></heading>
</div>
</template>

<script>
import Heading from '@/components/general/heading'

export default {
  components: { Heading },
  props: {
    title: {
      type: String,
      required: true
    },
    stepped: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'Add'
    }
  },
  methods: {
    addClicked () {
      this.$emit('add')
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.heading a.is-stepped {
  position: relative;
  top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/general/add-heading.vue